import axios from '@/api/axios'
// 创建插件
export const setUserOnline = (params) => {
  return axios({
    method: 'get',
    url: `/api/schedule/setUserOnline`,
    params,
  })
}
